/**
 * Legacy-Redirect: /sites → /dashboard — Issue #36 (Dennis-Entscheid, 2026-09-02)
 *
 * Sites (altes Whitelist-Feature) wird vorerst nicht mehr angeboten.
 * Nav-Eintrag entfernt (siehe layouts/nav.ts, LEGACY_PATH_REDIRECTS), Route
 * bleibt als Redirect erreichbar. features/sites/* bleibt bestehen, nur der
 * Zugang ist gekappt.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/sites')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard', replace: true })
  },
  component: () => null,
})
